import { Component, OnInit, Input } from '@angular/core';
import { Attendee } from '../Models/Attendee';
import { UntypedFormControl, UntypedFormGroup, Validators, UntypedFormBuilder, FormArray } from '@angular/forms';
import { Constants } from 'src/app/shared/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { UserService } from '../services/user.service';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Component({
    selector: 'app-attendee-form',
    templateUrl: './attendee-form.component.html'
})

export class AttendeeFormComponent implements OnInit {
    attendeeForm: UntypedFormGroup;

    //setting show condition
    show = false;

    // Basic Information
    first_name = new UntypedFormControl('', Validators.required);
    last_name = new UntypedFormControl('', Validators.required);
    t_shirt = new UntypedFormControl('');
    add_shirt = new UntypedFormControl(false);
    gender = new UntypedFormControl('', Validators.required);
    age = new UntypedFormControl('', Validators.required);
    email = new UntypedFormControl('', Validators.required);
    personal_phone_number = new UntypedFormControl('', Validators.required);

    food_allergies = new UntypedFormControl('');
    comments_concerns = new UntypedFormControl('');

    // Emergency Information
    emergency_contact_first_name = new UntypedFormControl('', Validators.required);
    emergency_contact_last_name = new UntypedFormControl('', Validators.required);
    emergency_email = new UntypedFormControl('', Validators.required);
    emergency_contact_phone_number = new UntypedFormControl('', Validators.required);
    emergency_contact_relationship = new UntypedFormControl('', Validators.required);

    // Church Information
    your_churches = new UntypedFormControl('', Validators.required);
    your_church = new UntypedFormControl('');
    your_church_point_of_contact_name = new UntypedFormControl('');
    your_church_point_of_contact_number = new UntypedFormControl('');
    state = new UntypedFormControl('');

    // Basic Values
    max_index = 0;
    current_index = 0;
    days_attending = '';

    // Submit button disabled
    button_disabled = false;

    currentAttendee: Attendee;
    shouldSlice = true;

    emptyAttendeeModel = new Attendee();

    // Lists
    people = [];
    sizes = Constants.SIZES;
    genders = Constants.GENDERS;
    states = Constants.STATES;
    church_list = Constants.CHURCH_LIST;
    days_chosen = [
        { name: 'Thursday', selected: true, id: 1 },
        { name: 'Friday', selected: true, id: 2 },
        { name: 'Saturday', selected: true, id: 3 },
        { name: 'Sunday', selected: true, id: 4 }
        
        // { name: 'Friday', selected: true, id: 1 },
        // { name: 'Saturday', selected: true, id: 2 },
        // { name: 'Sunday', selected: true, id: 3 }
    ];
    days_bool = [
        true, true, true, true
    ];


    constructor(private fb: UntypedFormBuilder, private http: HttpClient, private userService: UserService) {
        this.attendeeForm = fb.group({

            // Basic Information
            'first_name': this.first_name,
            'last_name': this.last_name,
            't_shirt': this.t_shirt,
            'add_shirt': this.add_shirt,
            'gender': this.gender,
            'age': this.age,
            'email': this.email,
            'personal_phone_number': this.personal_phone_number,
            'food_allergies': this.food_allergies,
            'comments_concerns': this.comments_concerns,

            // Emergency Information
            'emergency_contact_first_name': this.emergency_contact_first_name,
            'emergency_contact_last_name': this.emergency_contact_last_name,
            'emergency_contact_phone_number': this.emergency_contact_phone_number,
            'emergency_email': this.emergency_email,
            'emergency_contact_relationship': this.emergency_contact_relationship,

            // Church Information
            'your_churches': this.your_churches,
            'your_church': this.your_church,
            'your_church_point_of_contact_name': this.your_church_point_of_contact_name,
            'your_church_point_of_contact_number': this.your_church_point_of_contact_number,
            'state': this.state,

            days: this.fb.array(this.days_bool),
        });
    }

    ngOnInit() {
        this.loadAttendees();
        this.checkChurch();
    }

    // CRUD Options
    // Add attendee by creating a new attendee and navigating to it.
    // Previous form must be valid before moving on.
    // Must show active on new form.
    addAttendee() {
        // Check if church value is set to standard value or Other, and updates the form properly
        this.checkChurch();

        // If the form is valid, updates the service with the new value
        if (this.attendeeForm.valid) {
            const attendee = new Attendee();

            // Update attendee fields when valid form
            attendee.first_name = this.first_name.value;
            attendee.last_name = this.last_name.value;
            attendee.t_shirt = this.t_shirt.value;
            attendee.add_shirt = this.add_shirt.value;
            attendee.gender = this.gender.value;
            attendee.age = this.age.value;

            // attendee.medical = this.medical.value;
            attendee.email = this.email.value;
            attendee.personal_phone_number = this.personal_phone_number.value;
            attendee.food_allergies = this.food_allergies.value;
            attendee.comments_concerns = this.comments_concerns.value;

            //Emergency section
            attendee.emergency_contact_first_name = this.emergency_contact_first_name.value;
            attendee.emergency_contact_last_name = this.emergency_contact_last_name.value;
            attendee.emergency_contact_phone_number = this.emergency_contact_phone_number.value;
            attendee.emergency_contact_relationship = this.emergency_contact_relationship.value;
            attendee.emergency_email = this.emergency_email.value;

            // Church Section
            attendee.your_church = this.your_church.value;
            attendee.your_church_point_of_contact_name = this.your_church_point_of_contact_name.value;
            attendee.your_church_point_of_contact_number = this.your_church_point_of_contact_number.value;
            attendee.state = this.state.value;

            // Updates days attending and cost before pushing change
            this.numDaysCheck();
            attendee.days_attending = this.days_attending;
            attendee.cost = this.calculateAttendeeCost();

            // Updates the attendee to the service when the form is valid
            this.userService.addAttendee(this.current_index, attendee);

            this.currentAttendee = attendee;

            if (this.shouldSlice) {
                this.people.splice(this.max_index, 1);
            }

            this.people[this.current_index] = attendee;
        }
    }

    // When a user clicks to add a new attendee, updates list of registers and create clean form
    createNewAttendee() {

        // If the form is valid, add attendee to people list, then set the current attendee the new person in people list
        if (this.attendeeForm.valid) {
            this.people.push(this.emptyAttendeeModel);

            this.max_index++;
            this.current_index = this.max_index;

            // Fills in checkboxes to attend everyday
            this.attendeeForm.setControl('days', this.fb.array(this.days_bool));

            // Copy church info to every other register. save work for leaders
            this.people[this.max_index].your_church = this.your_church.value;
            this.people[this.max_index].your_church_point_of_contact_name = this.your_church_point_of_contact_name.value;
            this.people[this.max_index].your_church_point_of_contact_number = this.your_church_point_of_contact_number.value;

            // Update current attendee
            this.currentAttendee = this.people[this.max_index];

            // Make sure the last index should be deleted since we just added an empty object into people
            this.shouldSlice = true;

            // Bind to UI
            this.bindListToForm();
            this.your_churches.setValue('Other');

            // Scroll to top of page
            this.scroll();
        }
    }

    // Loads list of attendees from service.
    loadAttendees() {
        // Grabs attendees from the service
        const attendees = this.userService.getAllRegisters();

        // If attendees exist, loads attendees, otherwise create new attendee and add to people list
        if (attendees.length > 0) {
            this.people = attendees;

            // Updates indices to correct attendee.
            this.max_index = this.people.length - 1;
            this.current_index = this.max_index;

            this.currentAttendee = this.people[this.current_index];

            this.attendeeForm.reset();

            // Make sure the last index should not be deleted
            this.shouldSlice = false;

            // Puts attendee values to form after resetting.
            this.bindListToForm();

        } else {
            // Create new attendee and add to the current empty people list
            this.people.push(this.emptyAttendeeModel);
            this.currentAttendee = this.people[0];
            this.max_index = 0;
            this.current_index = 0;
        }
    }

    // Must navigate to specific attendee and update active pagination
    loadAttendee(attendee: Attendee, new_index: number) {

        // Set new current attendee for active setting
        this.currentAttendee = attendee;

        // Pull in target attendee data and put into form
        this.bindListToForm();

        // Make sure to update days attending when switching
        this.rebindDaysCheck();

        // Updates current index to the attendee we're loading
        this.current_index = new_index;

        // Make sure the last index should not be deleted
        this.shouldSlice = false;
    }

    // Deletes attendee from current list
    deleteAttendee(index) {
        if (index >= 0) {

            // Deletes Attendee from list
            this.people.splice(index, 1);
            this.max_index--;

            // Resets current attendee and index to the first one
            this.current_index = index - 1;
            this.currentAttendee = this.people[this.current_index];
            this.bindListToForm();
        }
    }

    // Checks if Other or N/A church is selected
    checkChurch() {
        if (this.your_churches.value === 'N/A') {
            this.your_church.setValue('N/A');
            this.your_church_point_of_contact_name.setValue('N/A');
            this.your_church_point_of_contact_number.setValue('(000) (000)-0000');
        } else if (!(this.your_churches.value === 'Other')) {
            this.your_church.setValue(this.your_churches.value);
        }

        // Makes sure the list is always set to what's in the Church Name box
        // If not, then is set to Other
        if (this.church_list.includes(this.your_church.value, 0)) {
            this.your_churches.setValue(this.your_church.value);
        }
        if (this.your_churches.value === '' || this.your_churches.value == null) {
            this.your_churches.setValue('Other');
        }
    }

    // Makes sure to set value of the days attending string based on the checked boxes
    numDaysCheck() {
        const dates = this.attendeeForm.get('days').value;

        this.days_attending = '';

        if (dates[0]) {
            this.days_attending += 'Thursday, ';
        }
        if (dates[1]) {
            this.days_attending += 'Friday, ';
        }
        if (dates[2]) {
            this.days_attending += 'Saturday, ';
        }
        if (dates[3]) {
            this.days_attending += 'Sunday';
        }
    }

    // Checks if the days are binded properly.
    rebindDaysCheck() {
        this.attendeeForm.setControl('days', this.fb.array([
            this.currentAttendee.days_attending.includes('Thursday'),
            this.currentAttendee.days_attending.includes('Friday'),
            this.currentAttendee.days_attending.includes('Saturday'),
            this.currentAttendee.days_attending.includes('Sunday')
        ]));
    }

    // Scrolls to top of page
    scroll() {
        const scrollToTop = window.setInterval(() => {
            const pos = window.pageYOffset;
            if (pos > 0) {
                // How far to scroll on each step
                window.scrollTo(0, pos - 40);
            } else {
                window.clearInterval(scrollToTop);
            }
        }, 16);
    }

    // Binding
    // Updates the form's values with the contents from the list
    bindListToForm() {
        this.checkChurch();

        this.first_name.setValue(this.currentAttendee.first_name);
        this.last_name.setValue(this.currentAttendee.last_name);
        this.t_shirt.setValue(this.currentAttendee.t_shirt);
        this.add_shirt.setValue(this.currentAttendee.add_shirt);
        this.gender.setValue(this.currentAttendee.gender);
        this.age.setValue(this.currentAttendee.age);
        this.email.setValue(this.currentAttendee.email);
        this.personal_phone_number.setValue(this.currentAttendee.personal_phone_number);
        this.food_allergies.setValue(this.currentAttendee.food_allergies);
        this.comments_concerns.setValue(this.currentAttendee.comments_concerns);

        // Emergency section
        this.emergency_contact_first_name.setValue(this.currentAttendee.emergency_contact_first_name);
        this.emergency_contact_last_name.setValue(this.currentAttendee.emergency_contact_last_name);
        this.emergency_email.setValue(this.currentAttendee.emergency_email);
        this.emergency_contact_phone_number.setValue(this.currentAttendee.emergency_contact_phone_number);
        this.emergency_contact_relationship.setValue(this.currentAttendee.emergency_contact_relationship);

        // Church Section
        this.your_church.setValue(this.currentAttendee.your_church);
        this.your_church_point_of_contact_name.setValue(this.currentAttendee.your_church_point_of_contact_name);
        this.your_church_point_of_contact_number.setValue(this.currentAttendee.your_church_point_of_contact_number);
        this.state.setValue(this.currentAttendee.state);
        

    }

    // Helper buttons for testing
    fullUpdate() {
        this.attendeeForm.setValue({
            first_name: 'Partial', last_name: 'monkey', t_shirt: 'M', gender: 'Male', age: 12,
            email: 'test@test.com', personal_phone_number: '1234567890', food_allergies: 'Not being at CVCF', 
            emergency_contact_first_name: 'Wise', emergency_contact_last_name: 'Turtle', 
            emergency_email: "cvcfhelp@gmail.com", emergency_contact_phone_number: '1234567890', 
            emergency_contact_relationship: 'Father', comments_concerns: 'I like puppies',
            your_churches: 'Other', your_church: 'Baptist', your_church_point_of_contact_name: 'asdafsdfasdfa', 
            your_church_point_of_contact_number: '1231231232', state: 'PA',
            days: this.days_bool
        });
        this.addAttendee();
    }

    //this function allow the button to hide or show fields
    toggleVisibility(elementId: string, show: boolean) {
        const element = document.getElementById(elementId);

        if (show) {
            element.style.display = 'block';
        } else {
            element.style.display = 'none';
        }
    }

    calculateAttendeeCost() {

        const daysAttendingMap =  new Map([
            ["Thursday",0.5],
            ["Friday",1], 
            ["Saturday",1], 
            ["Sunday",0.5]
        
        ]);

        let daysAttending = this.days_attending.split(", ");
        let totalCost = 0;

        for(let i = 0; i < daysAttending.length; i++) {
            if(daysAttendingMap.has(daysAttending[i])) {
                totalCost += daysAttendingMap.get(daysAttending[i]);
            }
        }
    if (totalCost <=.5){
        totalCost = 0
    }
    else if (totalCost <= 1) {
        totalCost = 50;
    }
    else if (totalCost <= 2) {
        totalCost = 100;
    }
    else {
        totalCost = 150;
    }

    if (this.add_shirt.value === true) {
        totalCost += 25;
    }

    return totalCost;


}
}